import { gql } from "@apollo/client";

import { BLOCKED_PHONE_NUMBER_FIELDS } from "src/graphql/fragments";

export const LIST_BLOCKED_PHONE_NUMBERS = gql`
  ${BLOCKED_PHONE_NUMBER_FIELDS}
  query listBlockedPhoneNumbers(
    $filter: BlockedPhoneNumberFilterInput
    $limit: Int
    $offset: Int
    $subaccountId: ID!
  ) {
    listBlockedPhoneNumbers(
      filter: $filter
      limit: $limit
      offset: $offset
      subaccountId: $subaccountId
    ) {
      totalCount
      blockedPhoneNumbers {
        ...BlockedPhoneNumberFields
      }
    }
  }
`;

export const CREATE_BLOCKED_PHONE_NUMBER = gql`
  ${BLOCKED_PHONE_NUMBER_FIELDS}
  mutation createBlockedPhoneNumber(
    $phoneNumber: String!
    $note: String
    $subaccountId: ID!
  ) {
    blockedPhoneNumberCreate(
      phoneNumber: $phoneNumber
      note: $note
      subaccountId: $subaccountId
    ) {
      ...BlockedPhoneNumberFields
    }
  }
`;

export const DELETE_BLOCKED_PHONE_NUMBER = gql`
  ${BLOCKED_PHONE_NUMBER_FIELDS}
  mutation deleteBlockedPhoneNumber($id: ID!, $subaccountId: ID!) {
    blockedPhoneNumberDelete(id: $id, subaccountId: $subaccountId) {
      ...BlockedPhoneNumberFields
    }
  }
`;
